import { render, staticRenderFns } from "./Authlayout.vue?vue&type=template&id=2c2e86e6&"
import script from "./Authlayout.vue?vue&type=script&lang=js&"
export * from "./Authlayout.vue?vue&type=script&lang=js&"
import style0 from "./Authlayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports